import { useEffect, useState } from "react";
import Spinner from "@brighthr/component-spinner";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import Button from "shared/UI/Buttons/Button";

type RetryButtonProps = {
  text?: string;
  onClick: VoidFunction;
  className?: string;
};

export const RetryButton = ({ text, onClick, className }: RetryButtonProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      const timerOne = setTimeout(onClick, 3000);
      const timerTwo = setTimeout(() => setIsLoading(false), 7000);
      return () => {
        clearTimeout(timerOne);
        clearTimeout(timerTwo);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <div className={classNames("mx-auto flex flex-col items-center", className)}>
      {text && <h3 className="mb-2 flex gap-2 items-center">{text}</h3>}
      <Button
        disabled={isLoading}
        className="w-[200px]"
        variant="outline"
        onClick={() => {
          setIsLoading(true);
        }}
        text={isLoading ? <Spinner className="stroke-brand-purple" size="xs" ariaLabel={t("buttons.loading")} /> : t("buttons.retry")}
      />
    </div>
  );
};
